import { ExtractedFirmQuoteDTO } from 'api';
import * as React from 'react';
import { Box, DataGrid, GridRowSelectionModel } from 'ui';

import { columns } from './columns';

interface FirmQuoteBulkFormProps {
  rows: ExtractedFirmQuoteDTO[];
  onSelectionChange?: (selectedRows: ExtractedFirmQuoteDTO[]) => void;
  processRowUpdate: (row: ExtractedFirmQuoteDTO) => void;
}

export const FirmQuoteBulkForm = ({ rows, onSelectionChange, processRowUpdate }: FirmQuoteBulkFormProps) => {
  const handleSelectionModelChange = (selectionModel: GridRowSelectionModel) => {
    if (onSelectionChange) {
      const selectedRows = rows.filter((row) => selectionModel.ids.has(row.index));
      onSelectionChange(selectedRows);
    }
  };

  return (
    <Box sx={{ height: '400px', width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        checkboxSelection
        disableRowSelectionOnClick
        getRowId={(row) => row.index}
        editMode="row"
        onRowSelectionModelChange={handleSelectionModelChange}
        autoHeight={false}
        processRowUpdate={processRowUpdate}
      />
    </Box>
  );
};
